import React from "react";
import '../About/About.css';


export default function About () {

    return (
        <div className='dog-container-main'>
            <h1 className="dog-content-title">App Dogs</h1>
            <p className="text-about">
                App dogs es una aplicación que se compone de dos partes:
            </p>
            <p className="text-about">
                Una API creada en Node.js y configurada con el framework Express, que se encarga de la comunicación con una base de datos creada en postgresql y un ORM para interactuar llamado Sequelize. 
            </p>
            <p className="text-about">
                El front-end se encarga de mostrar la información en una interfaz de usuario creado con React. Para la administración del estado de la aplicación se utiliza Redux.
            </p>
        
            
        </div>
    );
}